import {PhoneHQTooltip} from "ch3-ui-lib";
import {CalendarDays} from "lucide-react";
import {fullName, isInMeeting, TeamMember} from "./teamFilters";
import {CustomStatus, LocalTimeWithZone, MemberAvatar} from "./TeamMemberParts";
import {formatUntil} from "./teamFormat";
import {ConnectionTypeIcon} from "./ConnectionTypeIcon";
import TeamMemberActions from "./TeamMemberActions";
import {SelectCheckbox} from "../../features/callSurface/team/SelectCheckbox";

/** Grid card for one colleague on the Team tab. */
const Team = ({user, selected, onToggleSelected}: {user: TeamMember; selected?: boolean; onToggleSelected?: () => void}) => {
    const name = fullName(user);
    const meetingUntil = formatUntil(user.meetingUserStatus?.dateTo);

    return (
        <div data-testid="team-card" className={'flex min-w-0 flex-col rounded-xl border bg-surface border-line'}>
            <div className="flex flex-col gap-3 p-4">
                <div className="flex items-center gap-3 min-w-0">
                    {onToggleSelected && <SelectCheckbox name={name} checked={!!selected} onToggle={onToggleSelected}/>}
                    <MemberAvatar member={user}/>
                    <div className="min-w-0">
                        <div className="flex min-w-0 items-center gap-1.5">
                            <PhoneHQTooltip content={name}><div className={'truncate font-semibold text-ink'}>{name}</div></PhoneHQTooltip>
                            <ConnectionTypeIcon member={user}/>
                        </div>
                        {Boolean(user.position) &&
                            <div className={'truncate text-sm text-ink-muted'}>{user.position}</div>}
                    </div>
                </div>

                {Boolean(user.email) && (
                    <PhoneHQTooltip content={user.email}><div className={'truncate text-sm text-ink-muted'}>{user.email}</div></PhoneHQTooltip>
                )}

                <CustomStatus member={user}/>

                {isInMeeting(user) && (
                    <div data-testid="team-meeting" className="flex items-center gap-2 rounded-lg bg-danger-tint px-3 py-2 text-sm text-danger-ink">
                        <CalendarDays size={16} className="shrink-0"/>
                        <span className="font-medium">In a meeting</span>
                        {meetingUntil && <span className="truncate">· Expires at {meetingUntil}</span>}
                    </div>
                )}
            </div>

            <div className={'mt-auto flex items-center justify-between gap-2 border-t px-4 py-3 border-line'}>
                <LocalTimeWithZone timeZone={user.userTimeZone} className="min-w-0"/>
                <div className="ml-auto">
                    <TeamMemberActions member={user}/>
                </div>
            </div>
        </div>
    );
};

export default Team;
